module.exports = __webpack_public_path__ + "img/lateraltext-md.dfab6432.png";